import { useTranslation } from 'react-i18next';
import { getVinAffiliate } from '../../../services/affiliates';
import {
    buildCarVerticalUrl,
    trackVendorClick,
    withTrackingParams,
} from '../../../utils/vin/carverticalTracking';
import { isValidVin } from '../../../utils/vin/wmiDecoder';

const VinAffiliateCta = ({ placement = 'checkauto_report', vin = null }) => {
    const { t, i18n } = useTranslation();
    const aff = getVinAffiliate();
    if (!aff) return null;

    const hasVin = Boolean(vin) && isValidVin(vin);
    const isCarVertical = aff.partner === 'carvertical';
    const tracking = { placement, language: i18n.language };
    let href = aff.url;
    if (isCarVertical) {
        href = hasVin
            ? buildCarVerticalUrl(vin, tracking)
            : withTrackingParams(aff.url, tracking);
    }

    const handleClick = () => {
        trackVendorClick({
            vendor: aff.partner || 'carvertical',
            placement,
            vin: hasVin ? vin : null,
            language: i18n.language,
        });
    };

    return (
        <div className="vin-cta">
            <a
                href={href}
                target="_blank"
                rel="sponsored nofollow noopener"
                onClick={handleClick}
                className="vin-cta__bar"
            >
                <div className="vin-cta__brand">
                    <img
                        src="https://email-assets.carvertical.com/guids/CABINET_63db0cf9adebb153dce060de972ba7617d981bdfc84bb6d52dc86a1f6b6cd66f/images/logo.png"
                        alt="carVertical"
                        width="163"
                        height="27"
                        className="vin-cta__logo"
                        loading="lazy"
                    />
                </div>
                <div className="vin-cta__info">
                    <div className="vin-cta__title">{t('vinPartnerCta')}</div>
                    {aff.promoCode && (
                        <div className="vin-cta__promo">
                            {aff.discount && (
                                <span className="vin-cta__discount">
                                    -{aff.discount}
                                </span>
                            )}
                            <span className="vin-cta__promo-text">
                                {t('promoCode')}:{' '}
                                <b>{aff.promoCode.toUpperCase()}</b>
                            </span>
                        </div>
                    )}
                </div>
                <div className="vin-cta__button">
                    {t('vinPartnerBtn')}
                </div>
            </a>
            <small className="vin-cta__note">{t('vinPartnerNote')}</small>
        </div>
    );
};

export default VinAffiliateCta;
